import FormButton from "../../../components/FormButton"
import PageTitle from "../../../components/PageTitle"
import { useState, useEffect, useCallback } from "react"
import { getZohoTasks } from "../../../http/ZohoHttp"
import CreateZohoTaskModal from "../../../components/Renewal/CreateZohoTaskModal"
import { Pagination, Stack } from "@mui/material"
import Div from "../../../components/Div"
import Input from "../../../components/Input"


export default function AddZohoTask() {

    const [taskList, setTaskList] = useState([]);
    const [addZohoModal, setAddZohoModal] = useState(false)
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState()
    // const [isAscending, setIsAscending] = useState(true);
    const [initailTaskList, setInitialTaskList] = useState([])
   
    const itemsPerPage = 10;

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = taskList.slice(indexOfFirstItem, indexOfLastItem);


    // Calculate total pages
    const totalPages = Math.ceil(taskList.length / itemsPerPage);

    // Change page
    const paginate = (event, value) => {
        setCurrentPage(value);
    };

    const getZohoData = useCallback(async (date) => {
        const response = await getZohoTasks(date)
        if (response) {
            console.log(response)
            setTaskList(response.task)
            setInitialTaskList(response.task)
            // setInitialtaskList(response.task)
            // setInitialtaskList(response.task)
        } else {
            setTaskList([])
            // setInitialtaskList([])
        }
    }, [])

    useEffect(() => {
        const date = new Date()
        const currentYear = date.getFullYear(); // Get current year (YYYY)
        let currentMonth = (date.getMonth() + 1).toString(); // Get current month (1-12)

        // Ensure month is in MM format by adding a leading zero if needed
        if (currentMonth.length < 2) {
            currentMonth = '0' + currentMonth;
        }

        const formattedDate = `${currentYear}-${currentMonth}`; // Format as YYYY-MM

        getZohoData(formattedDate)
    }, [getZohoData])


    
    function handleSearchCustomer(event) {

        const search_item = event.target.value;

        console.log(search_item)
        const filteredList = initailTaskList.filter((customer) => {

            if ((customer && customer.subject)) {

                return customer.subject.toLowerCase().includes(search_item.toLowerCase());
            }
            else {
                return false
            }
        });
        setTaskList(filteredList);
        setSearch(search_item)

    }


    return (
        <>

            <PageTitle title='Create Zoho Task for Account Department' />


            {addZohoModal ? <CreateZohoTaskModal
                show={true.toString()} open handleClicked={setAddZohoModal} /> : null}

            <FormButton type="button" className="btn btn-primary" onClick={() => setAddZohoModal(true)}
                style={{opacity:'0.8'}}>Create Zoho Task</FormButton>

                 <Div className="btn-group toolbar-item" role="group" >
                
                                        <Input type='text' name='text' id='text' style={{ marginLeft: '50px' }} value={search}
                                            onChange={handleSearchCustomer}
                                        />
                                        </Div>

            {taskList.length > 0 && <table className="table" border="1" style={{ marginTop: '20px', opacity: '0.9' }}>
                <thead>
                    <tr>
                        <th>Task ID</th>
                        <th>Subject</th>
                        <th>Description</th>
                        <th>Time</th>
                    </tr>
                </thead>
                <tbody id="tableBody">
                    {currentItems.map((task) =>

                        <tr key={task.task_id}>
                            <td>
                                {task.task_id}
                            </td>
                            <td>{task.subject}</td>
                            <td>{task.description}</td>
                            <td>{task.date}</td>

                        </tr>
                    )

                    }
                </tbody>
            </table>
            }
            {currentItems.length > 0 ?
                <Stack spacing={2} style={{ marginTop: '20px' }}>
                    <Pagination count={totalPages} color="primary" page={currentPage} onChange={paginate}>

                    </Pagination>

                </Stack> : null
            }
        </>
    )
}